<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 20">
    <defs>
        <filter id="prefix__a">
            <feColorMatrix in="SourceGraphic" values="0 0 0 0 0.162953 0 0 0 0 0.850000 0 0 0 0 0.383161 0 0 0 1.000000 0"/>
        </filter>
    </defs>
    <g fill="none" fill-rule="evenodd" filter="url(#prefix__a)" transform="translate(.361)">
        <path fill="#FFF" d="M10.18 0C4.57 0 0 4.467 0 10c0 5.511 4.57 10 10.18 10 5.611 0 10.181-4.489 10.181-10 0-5.533-4.57-10-10.18-10zm5.136 7.378L8.868 13.71c-.09.089-.203.133-.316.133-.113 0-.227-.044-.317-.133L5.068 10.6c-.181-.178-.181-.444 0-.622.18-.178.452-.178.633 0l2.85 2.8 6.132-6.022c.18-.178.452-.178.633 0 .181.155.181.444 0 .622z"/>
    </g>
</svg>
